import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// i18n setup — mora da se importuje pre App-a da bi t() radio od prvog render-a
import "./locales/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
